import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import FilledAptitudeTestSection from 'src/entities/FilledAptitudeTestSection';
import { ApiFilledAptitudeTestQuestionResponse }
  from 'src/services/entity-factory/factories/FilledAptitudeTestQuestionFactory';

export interface ApiFilledAptitudeTestSectionResponse {
  sectionId: number;
  questions: ApiFilledAptitudeTestQuestionResponse[];
  passed: boolean;
}

interface ApiFilledAptitudeTestSectionCreateRequest {

}

export class FilledAptitudeTestSectionFactory extends BaseFactory<FilledAptitudeTestSection> {
  public toEntity(args: ApiFilledAptitudeTestSectionResponse): FilledAptitudeTestSection {
    return new FilledAptitudeTestSection({
      sectionId: args.sectionId,
      questions: args.questions ?
        args.questions.map(
          question => this.entityFactoryFactory.filledAptitudeTestQuestionFactory.toEntity(question)
        ) : [],
      passed: args.passed,
    });
  }

  public toRequest(filledAptitudeTestSection: FilledAptitudeTestSection): ApiFilledAptitudeTestSectionCreateRequest {
    return filledAptitudeTestSection;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/FilledAptitudeTestSectionFactory.tsx